import { useState } from 'react';
import { Grid } from '@mui/material';
import { FormContainer } from 'vetrf-ui';
import { useUserDataContext } from 'components/UserDataContext/context';
import { ReportModal } from 'components/ReportModal';
import { ROLES } from 'utils/consts/roles';
import { useGetPermission } from 'utils/hooks/useGetPermission';
import { getIsActual } from 'utils/getIsActual';
import { ObjectTypeId } from 'api/dict/params';
import { GmpDto } from 'modules/gmp/gmpRegistry/api/params';
import { registryApi } from 'modules/gmp/gmpRegistry/api/registryApi';
import { gmpFormApi } from '../../../../api/gmpFormApi';
import { RequestMotion } from './RequestMotion';
import { Information } from './Information/Information';
import { Transactions } from './Transactions/Transactions';

type ViewFormProps = {
  data: GmpDto;
  updateData: () => void;
  registryLink: string;
  id?: string;
  cardLink?: string;
};

export const ViewForm = ({ data, updateData, registryLink, id, cardLink }: ViewFormProps) => {
  const { userData } = useUserDataContext();
  const reportCreateDate = new URLSearchParams(window.location.search).get('reportCreateDate');
  const [isActualModalOpen, setIsActualModalOpen] = useState(!!reportCreateDate);

  const permissions = {
    edit: useGetPermission(ROLES.gmp.interact, userData, true),
    remove: useGetPermission(ROLES.gmp.interact, userData, true),
    print: useGetPermission(ROLES.gmp.interact, userData, true),
    erul: useGetPermission(ROLES.erul, userData, true),
    elk: useGetPermission(ROLES.elk, userData, true),
    eaes: useGetPermission(ROLES.eaes, userData, true),
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Information
          data={data}
          registryLink={registryLink}
          removeMethod={registryApi.deleteCard}
          updateData={updateData}
          permissions={permissions}
          cardLink={cardLink}
          id={id}
        />
      </Grid>
      <Grid item xs={12}>
        <RequestMotion
          id={data.id}
          history={data.movementList}
          cardData={data}
          updateData={updateData}
          addMovement={gmpFormApi.addMovement}
          removeMovement={gmpFormApi.removeMovement}
          objectTypeId={ObjectTypeId.GMP_COMPLIANCE_CONCLUSION}
          permissions={permissions}
        />
      </Grid>
      {permissions.eaes && (
        <Grid item xs={12}>
          <FormContainer>
            <Transactions updateData={updateData} data={data} permissions={permissions} />
          </FormContainer>
        </Grid>
      )}
      {reportCreateDate && isActualModalOpen && (
        <ReportModal
          onClose={() => {
            setIsActualModalOpen(false);
          }}
          label="Выписка из государственного реестра заключений о соответствии (GMP)"
          isActual={getIsActual(reportCreateDate, data.dataLastEditDate)!}
          reportCreateDate={reportCreateDate}
        />
      )}
    </Grid>
  );
};
